import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  const featured = articles.filter((a) => a.isFeatured);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-500 text-sm">
              实用教程、软件评测、数字生活指南，干货满满
            </p>
          </div>
          <Link
            to="/category/articles"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-300">·</span>
                  <span className="text-xs text-foreground-400">{article.readTime}阅读</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.summary}
                </p>
                <div className="flex items-center gap-2 flex-wrap">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center md:hidden">
          <Link
            to="/category/articles"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}